import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';
import { selectStats, selectLoading } from '../../../../redux/reducers/brand/ConfirmedDealsReducer';
import { formatCurrency } from '../../../../shared/helpers/WVFormatter';

const StatCard = ({ title, value, loading }) => (
  <div style={{ flex: '1 1 auto', minWidth: '95px' }}>
    <Card className="mb-0" style={{ height: '100%' }}>
      <CardBody className="py-2 px-3 text-center d-flex flex-column align-items-center justify-content-center">
        {loading ? (
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
        ) : (
          <>
            <p className="text-muted mb-1" style={{ fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.04em', lineHeight: 1.2 }}>
              {title}
            </p>
            <div className="font-weight-bold" style={{ fontSize: '1.05rem', lineHeight: 1.2 }}>
              {value}
            </div>
          </>
        )}
      </CardBody>
    </Card>
  </div>
);

StatCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  loading: PropTypes.bool,
};

StatCard.defaultProps = {
  loading: false,
};

const Stats = ({ stats, loading }) => {
  const formatCurrencyGroup = (byCurrency) => {
    const currencies = Object.keys(byCurrency).sort();
    if (currencies.length === 0) return formatCurrency(0, 'usd', 2, true);
    return currencies.map(currency =>
      formatCurrency(byCurrency[currency], currency.toLowerCase(), 2, true)
    ).join(' / ');
  };

  const formatCompactNumber = (num) => {
    if (!num) return '—';
    if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
    if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
    return num.toLocaleString();
  };

  return (
    <div className="d-flex align-items-stretch" style={{ gap: '8px' }}>
      <StatCard title="Booked" value={stats.booked.count} loading={loading} />
      <StatCard title="Published" value={stats.published.count} loading={loading} />
      <StatCard title="Remaining" value={stats.remaining.count} loading={loading} />
      <StatCard title="Booked Amount" value={formatCurrencyGroup(stats.booked.byCurrency)} loading={loading} />
      <StatCard title="Published Amount" value={formatCurrencyGroup(stats.published.byCurrency)} loading={loading} />
      <StatCard title="Published %" value={`${stats.percentPublished}%`} loading={loading} />
      <StatCard title="Avg Deal Size" value={formatCurrencyGroup(stats.avgDealSize.byCurrency)} loading={loading} />
      <StatCard title="% New" value={`${stats.percentNew.percent}%`} loading={loading} />
      <StatCard title="% Rebuy" value={`${stats.percentRebuy.percent}%`} loading={loading} />
      <StatCard title="Avg V30" value={formatCompactNumber(stats.avgV30)} loading={loading} />
    </div>
  );
};

Stats.propTypes = {
  stats: PropTypes.shape({
    booked: PropTypes.shape({
      byCurrency: PropTypes.objectOf(PropTypes.number),
      count: PropTypes.number,
    }),
    published: PropTypes.shape({
      byCurrency: PropTypes.objectOf(PropTypes.number),
      count: PropTypes.number,
    }),
    trackedCount: PropTypes.number,
    percentPublished: PropTypes.number,
    remaining: PropTypes.shape({
      count: PropTypes.number,
    }),
    avgDealSize: PropTypes.shape({
      byCurrency: PropTypes.objectOf(PropTypes.number),
    }),
    avgV30: PropTypes.number,
    percentNew: PropTypes.shape({
      percent: PropTypes.number,
      count: PropTypes.number,
    }),
    percentRebuy: PropTypes.shape({
      percent: PropTypes.number,
      count: PropTypes.number,
    }),
  }).isRequired,
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  stats: selectStats(state),
  loading: selectLoading(state),
});

export default connect(mapStateToProps)(Stats);